var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5319 9.96992L9.47188 15.0299C8.82188 14.3799 8.42188 13.4899 8.42188 12.4999C8.42188 10.5199 10.0219 8.91992 12.0019 8.91992C12.9919 8.91992 13.8819 9.31992 14.5319 9.96992Z",
    stroke: "#0D2645",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8198 6.27047C16.0698 4.95047 14.0698 4.23047 11.9998 4.23047C8.46984 4.23047 5.17984 6.31047 2.88984 9.91047C1.98984 11.3205 1.98984 13.6905 2.88984 15.1005C3.67984 16.3405 4.59984 17.4105 5.59984 18.2705",
    stroke: "#0D2645",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.42188 20.0297C9.56187 20.5097 10.7719 20.7697 12.0019 20.7697C15.5319 20.7697 18.8219 18.6897 21.1119 15.0897C22.0119 13.6797 22.0119 11.3097 21.1119 9.89969C20.7819 9.37969 20.4219 8.88969 20.0519 8.42969",
    stroke: "#0D2645",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.5114 13.1992C15.2514 14.6092 14.1014 15.7592 12.6914 16.0192",
    stroke: "#0D2645",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47 15.0293L2 22.4993",
    stroke: "#0D2645",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0013 2.5L14.5312 9.97",
    stroke: "#0D2645",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.ff718d9b9d393eb416f679ded9e86b62.svg";
export { ForwardRef as ReactComponent };